<template>
  <div class="whole">
    <h3>{{$t("title.Introduction")}}</h3>
    <hr/>
    <div class="text">
      <br/>
      <br/>
      {{$t("title.Introduction1")}}<br/><br/><br/>
      {{$t("title.Introduction2")}}<br/><br/>

    </div>
  </div>
</template>

<script>
export default {
  name: "Introduction"
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
.text{
  margin-top: 20px;
}
</style>